/**
 * Редакция партнёрской оферты — одна на весь фронт.
 *
 * Версия уходит на сервер в `offer.version` при регистрации и хранится как
 * доказательство того, что именно принял партнёр. Дата той же редакции
 * печатается на странице оферты и в тексте документа.
 *
 * Держать их двумя литералами нельзя: разъехавшись, они дадут акцепт
 * редакции, которой человек не видел. Поэтому константа одна, а
 * человекочитаемая дата из неё считается.
 *
 * Значение обязано совпадать с front matter `assets/legal/partner_terms.md`
 * мобильного приложения (`version: 2026-08-25`): текст оферты в вебе и в
 * приложении один, и версия у него одна.
 */

/** Версия редакции — ровно то, что уходит в `offer.version`. */
export const PARTNER_OFFER_VERSION = '2026-08-25';

/** Адрес полного текста оферты. Зашит в мобильное приложение — не менять. */
export const PARTNER_OFFER_URL = '/terms/partners';

const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

/**
 * `2026-08-25` → `25 августа 2026 года`.
 *
 * Через `Intl` не делаем намеренно: в jsdom и в старых сборках рантайма
 * русская локаль подставляется не всегда, а дата редакции — юридический
 * реквизит, который обязан выглядеть одинаково везде.
 */
export function formatOfferDate(version: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(version);
  if (!match) return version;

  const [, year, month, day] = match;
  const monthName = MONTHS_GENITIVE[Number(month) - 1];
  if (!monthName) return version;

  return `${Number(day)} ${monthName} ${year} года`;
}

/** Дата редакции для показа человеку: «25 августа 2026 года». */
export const PARTNER_OFFER_UPDATED_AT = formatOfferDate(PARTNER_OFFER_VERSION);

/** `2026-08-24 12:00:00` → `24.08.2026`. Время акцепта в кабинете не нужно. */
export function formatOfferAcceptedAt(raw: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (!match) return raw;

  const [, year, month, day] = match;
  return `${day}.${month}.${year}`;
}
